module.exports = __webpack_public_path__ + "img/foto21.e70a5e40.jpg";